export default function CheckSvg() {
  return (
    <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.578 4.12a1.767 1.767 0 0 1 2.524 2.474l-9.406 11.758a1.766 1.766 0 0 1-2.543.048l-6.236-6.233a1.767 1.767 0 1 1 2.5-2.5l4.932 4.934 8.182-10.425a.587.587 0 0 1 .048-.054l-.002-.001z"
        fill="#fff"/>
    </svg>
  );
}
